﻿import {Utils} from "../Utils/Utils";
import {UIState} from "../enums";
import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";

//public delegate void OnTimeLoaded();

export class TimeManager extends MonoBehaviour {

    Initialized = false;

    get DayUniqId() {
        return Utils.DayId(this.serverTime);
    }

    get serverTime() {
        return Date.now();
    }

    TicksToDayId(ticks) {
        return Utils.DayId(new Date(ticks));
    }

    Awake() {
        this.Initialized = false;
    }

    Init() {
        this.requestTime();
    }

    OnApplicationPause(pause) {
        if (!pause) this.requestTime();
    }

    requestTime() {
        this.Initialized = true;
        if (!Core.Player.Timers.registrationTime) {
            Core.Player.Timers.registrationTime = this.serverTime;
        }
        if (!Core.Player.Timers.lastActionTime) {
            Core.Player.Timers.lastActionTime = this.serverTime;
        }

       if (Core.UI.state != UIState.Loading) {
           Core.UI.moneyBox.Check();
       }
       this.emit("TimeLoaded");
    }

    Update() {
        this.requestTime();
    }
}
